import axios from '../utils/axios';
import Constants from './types';
import { getSessionId, getPayloadFromError } from '../utils';
import { getCustomFields } from './customFields';
import {
  getAdminConfig,
  getPerformanceMetrics,
  getSystemConfiguration
} from './systemConfig';
import history from '../utils/history';

export const getEntities = theSessionId => {
  const sessionId = theSessionId ? theSessionId : getSessionId();
  return (dispatch, getState) => {
    dispatch(getEntitiesRequest());
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/entities',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(getEntitiesSuccess(res.data));
        const { entities, customFields, fields } = getState();
        if (customFields.customFields.length === 0) {
          const entityVersionId = !entities.selected
            ? res.data[0].entityVersionId
            : entities.selected.entityVersionId;
          dispatch(getAdminConfig(sessionId));
          dispatch(getCustomFields(entityVersionId, sessionId));
          dispatch(getSystemConfiguration(entityVersionId, sessionId));
          dispatch(getPerformanceMetrics(sessionId));
        }
        if (fields.entityFields.length === 0) {
          dispatch(setEntityFields(res.data));
        }
      })
      .catch(err => {
        dispatch(getEntitiesFailure(err));
      });
  };
};

// This has useful info on downloading files using axios
// https://stackoverflow.com/questions/41938718/how-to-download-files-using-axios
//
export const exportEntity = (entityName, entityVersionId) => {
  return dispatch => {
    axios({
      url:
        '/entityDownloadService?entityName=' +
        entityName +
        '&entityVersionId=' +
        entityVersionId,
      method: 'GET',
      responseType: 'blob' // important
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', entityName + '.xml');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      dispatch(clearEntitiesError);
    });
  };
};

export const exportRecords = entityVersionId => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'POST',
      url: '/openempi-ws-rest/1.0/records/export',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId: entityVersionId
      }
    })
      .then(res => {
        dispatch(exportEntityRecordsSuccess(res.data));
      })
      .catch(err => {
        dispatch(exportEntityRecordsFailure(err));
      });
  };
};

export const exportConfig = entityVersionId => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'POST',
      url: '/openempi-ws-rest/1.0/entities/config',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId: entityVersionId
      }
    })
      .then(res => {
        dispatch(exportEntityConfigSuccess(res.data));
      })
      .catch(err => {
        dispatch(exportEntityConfigFailure(err));
      });
  };
};

export const addEntity = entity => {
  const sessionId = getSessionId();
  return dispatch => {
    dispatch(saveEntityRequest());
    axios({
      method: 'POST',
      url: '/openempi-ws-rest/1.0/entities',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      data: entity
    })
      .then(res => {
        dispatch(addEntitySuccess(res.data));
        dispatch(getSystemConfiguration(res.data.entityVersionId, sessionId));
        history.push('/entities');
      })
      .catch(err => {
        dispatch(addEntityFailure(err));
      });
  };
};

export const importEntityFromFile = userFileId => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'POST',
      url: `/openempi-ws-rest/1.0/entities/importFile/${userFileId}`,
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(importEntitySuccess(res.data));
        dispatch(getSystemConfiguration(res.data.entityVersionId, sessionId));
        history.push('/entities');
      })
      .catch(err => {
        dispatch(importEntityFailure(err));
      });
  };
};

/*
export const createEntityIndexes = entity => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'POST',
      url: `/openempi-ws-rest/1.0/entities/${entity.entityVersionId}/indexes`,
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        consoled.log('Succeeded in creating entity indexes.');
      })
      .catch(err => {
        dispatch(addEntityFailure(err));
      });
  };
};

export const dropEntityIndexes = entity => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'DELETE',
      url: `/openempi-ws-rest/1.0/entities/${entity.entityVersionId}/indexes`,
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        consoled.log('Succeeded in dropping entity indexes.');
      })
      .catch(err => {
        dispatch(addEntityFailure(err));
      });
  };
};*/

export const deleteEntity = entityId => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'delete',
      url: '/openempi-ws-rest/1.0/entities/' + entityId,
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(deleteEntitySuccess(res.data));
      })
      .catch(err => {
        dispatch(deleteEntityFailure(err));
      });
  };
};

export const selectEntity = entity => {
  const sessionId = getSessionId();
  return dispatch => {
    dispatch(getCustomFields(entity.entityVersionId, sessionId));
    dispatch(getSystemConfiguration(entity.entityVersionId, sessionId));
    dispatch(setEntityRequest(entity));
  };
};

export const saveEntity = (entityVersionId, entity) => {
  const sessionId = getSessionId();
  return dispatch => {
    dispatch(saveEntityRequest());
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/entities/' + entityVersionId,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      data: entity
    })
      .then(res => {
        dispatch(saveEntitySuccess(res.data));
        history.push('/entities');
      })
      .catch(err => {
        dispatch(saveEntityFailure(err));
      });
  };
};

export const clearEntitiesError = () => {
  return {
    type: Constants.ENTITIES_CLEARERROR
  };
};

const setEntityRequest = entity => {
  return {
    type: Constants.ENTITY_SELECT,
    payload: entity
  };
};

const getEntitiesRequest = () => {
  return {
    type: Constants.ENTITIES_GET_REQUEST
  };
};

const saveEntityRequest = () => {
  return {
    type: Constants.ENTITIES_SAVE_REQUEST
  };
};

const getEntitiesSuccess = data => {
  return {
    type: Constants.ENTITIES_GET_SUCCESS,
    payload: data
  };
};

const getEntitiesFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.ENTITIES_GET_FAILURE,
    payload
  };
};

const deleteEntitySuccess = data => {
  return {
    type: Constants.ENTITIES_DELETE_SUCCESS,
    payload: data
  };
};

const deleteEntityFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.ENTITIES_DELETE_FAILURE,
    payload
  };
};

const addEntitySuccess = data => {
  return {
    type: Constants.ENTITIES_ADD_SUCCESS,
    payload: data
  };
};

const addEntityFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.ENTITIES_ADD_FAILURE,
    payload
  };
};

const importEntitySuccess = data => {
  return {
    type: Constants.ENTITIES_IMPORT_SUCCESS,
    payload: data
  };
};

const importEntityFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.ENTITIES_IMPORT_FAILURE,
    payload
  };
};

const saveEntitySuccess = data => {
  return {
    type: Constants.ENTITIES_SAVE_SUCCESS,
    payload: data
  };
};

const saveEntityFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.ENTITIES_ADD_FAILURE,
    payload
  };
};

const exportEntityRecordsSuccess = data => {
  return {
    type: Constants.ENTITIES_CLEARERROR
  };
};

const exportEntityRecordsFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.ENTITY_RECORDS_EXPORT_FAILURE,
    payload
  };
};

const exportEntityConfigSuccess = data => {
  return {
    type: Constants.ENTITIES_CLEARERROR
  };
};

const exportEntityConfigFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.ENTITY_CONFIG_EXPORT_FAILURE,
    payload
  };
};

const setEntityFields = data => {
  return {
    type: Constants.FIELDS_FIRST_ENTITY,
    payload: data
  };
};
